/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getManyBaseTitleControllerTitle } from '../fn/title/get-many-base-title-controller-title';
import { GetManyBaseTitleControllerTitle$Params } from '../fn/title/get-many-base-title-controller-title';
import { GetManyTitleResponseDto } from '../models/get-many-title-response-dto';
import { getOneBaseTitleControllerTitle } from '../fn/title/get-one-base-title-controller-title';
import { GetOneBaseTitleControllerTitle$Params } from '../fn/title/get-one-base-title-controller-title';
import { Title } from '../models/title';

@Injectable({ providedIn: 'root' })
export class TitleApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseTitleControllerTitle()` */
  static readonly GetManyBaseTitleControllerTitlePath = '/api/titles';

  /**
   * Retrieve multiple Titles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseTitleControllerTitle()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseTitleControllerTitle$Response(params?: GetManyBaseTitleControllerTitle$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyTitleResponseDto>> {
    const obs = getManyBaseTitleControllerTitle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Titles.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseTitleControllerTitle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseTitleControllerTitle(params?: GetManyBaseTitleControllerTitle$Params, context?: HttpContext): Observable<GetManyTitleResponseDto> {
    const resp = this.getManyBaseTitleControllerTitle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyTitleResponseDto>): GetManyTitleResponseDto => r.body)
    );
  }

  /** Path part for operation `getOneBaseTitleControllerTitle()` */
  static readonly GetOneBaseTitleControllerTitlePath = '/api/titles/{id}';

  /**
   * Retrieve a single Title.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseTitleControllerTitle()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseTitleControllerTitle$Response(params: GetOneBaseTitleControllerTitle$Params, context?: HttpContext): Observable<StrictHttpResponse<Title>> {
    const obs = getOneBaseTitleControllerTitle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Title.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseTitleControllerTitle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseTitleControllerTitle(params: GetOneBaseTitleControllerTitle$Params, context?: HttpContext): Observable<Title> {
    const resp = this.getOneBaseTitleControllerTitle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Title>): Title => r.body)
    );
  }

}
